import { initStore } from "./store";

const configureStore = () => {
  const actions = {

    SET_ISPDFTOTEXTSEVERBUSY: (state, payload) => {
      return {
        // ...state,
        pdfToTextStore: {
          ...state.pdfToTextStore,
          isPdfToTextServerBusy: payload,
        }
      };
    },
  };

  initStore(actions, {
    pdfToTextStore: {
      isPdfToTextServerBusy: false,
    }
  });
};

export default configureStore;
